// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1KzQo","errorLogs":"styles_errorLogs__3htyI"};